const WA_NUMBER = "919970958370";
const WA_MESSAGE = "Hi, I want to know more about ClassNora for my daycare.";
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;

export default function WhatsAppButton() {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with ClassNora on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 group"
    >
      {/* Tooltip */}
      <span className="hidden sm:block opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-[#1a1a1a] text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap shadow-lg pointer-events-none">
        Chat on WhatsApp
      </span>

      {/* Button */}
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full shadow-xl transition-transform duration-200 group-hover:scale-110 group-active:scale-95" style={{ backgroundColor: "#25D366" }}>
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full animate-ping opacity-30" style={{ backgroundColor: "#25D366" }} />
        {/* WhatsApp icon */}
        <svg viewBox="0 0 32 32" width="28" height="28" fill="white" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M16.002 3C9.373 3 4 8.373 4 15.002c0 2.157.575 4.2 1.576 5.967L4 29l8.262-1.555A11.957 11.957 0 0016.002 28C22.627 28 28 22.627 28 16.002 28 9.373 22.627 3 16.002 3zm0 21.778a9.762 9.762 0 01-5.028-1.394l-.36-.213-3.725.7.713-3.626-.235-.373A9.733 9.733 0 016.222 15c0-5.398 4.39-9.778 9.78-9.778 5.393 0 9.78 4.38 9.78 9.778 0 5.4-4.387 9.778-9.78 9.778zm5.364-7.317c-.293-.147-1.735-.856-2.003-.954-.269-.098-.464-.147-.66.147-.196.295-.758.955-.93 1.151-.17.196-.342.22-.635.074-.293-.147-1.238-.456-2.358-1.455-.872-.777-1.46-1.736-1.631-2.03-.171-.293-.018-.451.128-.597.132-.13.293-.342.44-.513.147-.17.196-.294.294-.489.098-.196.049-.366-.024-.514-.074-.147-.66-1.59-.904-2.176-.238-.572-.48-.494-.66-.504l-.562-.01c-.196 0-.514.074-.782.37-.27.295-1.026 1.003-1.026 2.447 0 1.443 1.05 2.838 1.197 3.035.147.196 2.065 3.153 5.003 4.42.7.302 1.247.482 1.673.618.703.224 1.343.192 1.849.116.563-.084 1.735-.709 1.98-1.394.245-.685.245-1.272.172-1.394-.073-.122-.269-.196-.562-.343z"/>
        </svg>
      </span>
    </a>
  );
}
